import { liveServices as liveServices$1, currentServices as currentServices$1 } from '../../internal/defaultServices.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const liveServices = liveServices$1;

/**
 * @since 2.0.0
 * @category fiberRefs
 */
const currentServices = currentServices$1;

export { currentServices, liveServices };
